import React from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from "devextreme-react/button";



export const PopupTitleWithIcon = (icon,title,fun, visibleCloseBtn = true, classNameColorIcon = '') => {
    return (
        <div className="mt10 popup-title-with-icon">
            {typeof icon === 'string' ?
            <i className={`dx-icon ${icon} icon-header-h3 main-color main-color-light ${classNameColorIcon}`}></i>
                :
            <FontAwesomeIcon className={`icon-header-h3 main-color main-color-light ${classNameColorIcon}`} icon={icon} />
            }
            <h3><strong>{title}</strong></h3>
            <div className="dx-toolbar-after">
                <div className="dx-item dx-toolbar-item dx-toolbar-button">
                    <div className="dx-item-content dx-toolbar-item-content">
                        <Button icon="close" visible={visibleCloseBtn} className="dx-button-mode-text mr20"  onClick={fun}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

